import { normalize } from 'normalizr';

import api from 'helpers/api';
import * as schemas from '../schemas';

export function fetchReferralCoupon(id) {
  return api.backend
    .get(`referral_coupons/${id}`)
    .then(response =>
      normalize(response.data.referralCoupon, schemas.referralCoupon)
    );
}



// WEBPACK FOOTER //
// ./src/api/referralCoupons.js